module.exports = __webpack_public_path__ + "img/ic_flat_coin@2x.4397c0c7.png";